import MeritoButton from "../../../components/common/MeritoButtons/MeritoButtons";
import { getLocalUser } from "../../../components/functions/utilities";
import {
	AuthMethods,
	EmailOtpSteps,
	IIntegrationPartner,
	IpNames,
	PENDING_CREDENTIAL_CONFIRMATION_IPS,
	UserRole,
} from "../../../interfaces/interfaces";
import { useAppSelector } from "../../../redux/reduxHooks";
import { IpRestS } from "../../../rest/ipRest-service";
import { setRPAValidationObj } from "../IpScreen/PasswordForm/PasswordForm";
import { ipShortNames } from "./emailOtpHelper";
import styles from "./OtpConfirmation.module.scss";

type Props = {
	ip: IIntegrationPartner;
	emailOtpSteps: {
		currentStep: number;
		previousStep: number;
	};
	setEmailOtpSteps: React.Dispatch<React.SetStateAction<{
		currentStep: number;
		previousStep: number;
	}>>;
	formValues: {
		email: string;
		password: string;
		emailClient: string;
	};
	setStep: (value: number) => void;
	setSelectedIp: (value: IIntegrationPartner) => void;
	setSuccess: (value: boolean) => void;
};

const OtpConfirmation = ({ ip, emailOtpSteps, setEmailOtpSteps, setStep, formValues, setSelectedIp, setSuccess }: Props) => {
	const shortIpName = ipShortNames[ip?.companyName] ?? ip?.companyName;

	const currentUser = getLocalUser();
	const { currentClient } = useAppSelector((state) => state.agencyConfig)

	const handleNextStep = () => {
		if (PENDING_CREDENTIAL_CONFIRMATION_IPS.has(ip.companyName as IpNames)) {
			// Need to set `selectedIp` to the `ip` value
			setSelectedIp(ip);
			setSuccess(true);
			setStep(4);
		} else {
			setStep(9);
		}
		IpRestS.connectViaPasswordForm({
			email: formValues.email,
			password: ip?.authMethod == AuthMethods.email_otp_password ? formValues?.password : "",
			integrationPartner: ip,
			agencyClientId: currentUser?.role === UserRole.Agency ? currentClient?.id : null,
		});
		setRPAValidationObj();
	};

	return (
		<div className={styles.rootContainer}>
			<div className={styles.confirmationRootContainer}>
				<div className={styles.topContainer}>
					<div className={styles.logoContainer}>
						<img src={ip?.logo} alt="" />
					</div>
					<div className={styles.title}>
						Have You Set Up Email <br />
						Forwarding for {shortIpName} OTPs?
					</div>
				</div>
				<div className={styles.bottomContainer}>
					<MeritoButton
						type="primary-1"
						btnText="Yes, I’ve Set It Up"
						onClick={handleNextStep}
						size="lg"
						isRounded={true}
					/>
					<MeritoButton
						type="secondary-2"
						btnText="No, I Need Help"
						onClick={() => {
							setEmailOtpSteps(prev => ({
								currentStep: EmailOtpSteps.otpInstructions,
								previousStep: prev?.currentStep,
							}));
						}}
						size="lg"
						isRounded={true}
					/>
				</div>
			</div>
		</div>
	);
};

export default OtpConfirmation;
